import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import CrcCalculator from '../components/tools/CrcCalculator';

const CrcCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="crc-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="CRC Calculator"
        description="Compute CRC-8, CRC-16, or CRC-32 over arbitrary data using selectable standard polynomials."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="crc-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <CrcCalculator />
          <ToolGuideCta guidePath="/tools/crc-calculator/guide" toolName="CRC Calculator" />
        </div>
      </section>
    </div>
  );
};

export default CrcCalculatorPage;
